import {
  CAccordion,
  CAccordionBody,
  CAccordionHeader,
  CAccordionItem,
  CCol,
  CForm,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CLoadingButton,
  CRow,
} from '@coreui/react-pro'
import React, { useEffect, useState } from 'react'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { useNavigate } from 'react-router-dom'
import ToastComponent from 'src/components/common/TaostComponent'
import CommonService from 'src/service/CommonService'
const TimelineSetting = (props) => {
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false)
  const [timelineDetails, setTimelineDetails] = useState()
  useEffect(() => {
    CommonService.getTimelineSetting()
      .then((res) => {
        if (res.status === 200) {
          setTimelineDetails(res.data)
        }
      })
      .catch((e) => {
        ToastComponent(e.response?.data?.message, 'error')
        setLoader(false)
      })
  }, [])
  const validationSchema = Yup.object().shape({
    fantasy_points: Yup.string().required('Fantasy Points Per Match'),
    rs_per_inning: Yup.string().required('Score Per Match'),
  })
  const formik = useFormik({
    initialValues: {
      fantasy_points: timelineDetails?.fantasy_points,
      rs_per_inning: timelineDetails?.sc,
    },
    enableReinitialize: true,
    validationSchema,
    onSubmit: (data, actions) => {
      actions.resetForm()
      setLoader(true)
      CommonService.setTimelineSetting(data).then((res) => {
        if (res.status === 200) {
          ToastComponent(res.message, 'success')
          setLoader(false)
        }
      })
    },
  })
  return (
    <>
      <CRow>
        <CAccordion activeItemKey={1} alwaysOpen>
          <CAccordionItem itemKey={1}>
            <CAccordionHeader>
              {' '}
              <strong>Timeline Settings</strong>
            </CAccordionHeader>
            <CAccordionBody>
              <CForm className="row g-3" onSubmit={formik.handleSubmit}>
                <CCol md={6}>
                  <CFormLabel htmlFor="name" className="fw-bold">
                    Fantasy Points Per Match *
                  </CFormLabel>
                  <CFormInput
                    placeholder=""
                    type="number"
                    className={
                      'form-control' +
                      (formik.errors.fantasy_points && formik.touched.fantasy_points
                        ? ' is-invalid'
                        : '')
                    }
                    defaultValue={formik.values.fantasy_points}
                    onChange={formik.handleChange}
                    aria-label="fantasy_points"
                    id="fantasy_points"
                  />
                  {formik.errors.fantasy_points && formik.touched.fantasy_points && (
                    <CFormFeedback invalid>{formik.errors.fantasy_points}</CFormFeedback>
                  )}
                </CCol>
                <CCol md={6}>
                  <CFormLabel htmlFor="name" className="fw-bold">
                    Score Per Match *
                  </CFormLabel>
                  <CFormInput
                    placeholder=""
                    type="number"
                    className={
                      'form-control' +
                      (formik.errors.rs_per_inning && formik.touched.rs_per_inning
                        ? ' is-invalid'
                        : '')
                    }
                    defaultValue={formik.values.rs_per_inning}
                    onChange={formik.handleChange}
                    aria-label="rs_per_inning"
                    id="rs_per_inning"
                  />
                  {formik.errors.rs_per_inning && formik.touched.rs_per_inning && (
                    <CFormFeedback invalid>{formik.errors.rs_per_inning}</CFormFeedback>
                  )}
                </CCol>

                <CCol md={6}>
                  <CLoadingButton
                    type="submit"
                    color="success"
                    variant="outline"
                    loading={loader}
                    id="submit"
                  >
                    Submit
                  </CLoadingButton>
                </CCol>
              </CForm>
            </CAccordionBody>
          </CAccordionItem>
        </CAccordion>
      </CRow>
    </>
  )
}

export default TimelineSetting
